import { createAsyncThunk } from "@reduxjs/toolkit";
import type { TeacherPayoutVM } from "@shared-kernel/application/ports/teacher/teacher-repository";
import type { Dependencies } from "@redux/store";

export const teacherRetrievePayouts = createAsyncThunk<TeacherPayoutVM[], void, { extra: Partial<Dependencies> }>(
  "payouts/teacherRetrievePayouts",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.getTeacherPayouts();
  },
);
